module.exports = __webpack_public_path__ + "img/Character_Tartaglia_Thumb.b81c68b2.png";